// import { music1, music2, music3 } from "../../music";
import { music1, music2, music3 } from "../music";
export const part1 = [
  {
    name: "Live 12",
    nav: "",
  },
  {
    name: "All new features",
    nav: "",
  },
  {
    name: "What is Live?",
    nav: "",
  },
  {
    name: "Max for Live",
    nav: "",
  },
  {
    name: "Learn Live",
    nav: "",
  },
  {
    name: "Integrated hardware",
    nav: "",
  },
  {
    name: "Compare editions",
    nav: "",
  },
  {
    name: "Buy now",
    nav: "",
  },
];

export const part2 = [
  "Play freely with ideas",
  "Surprise yourself with sounds",
  "Work more intuitively",
  "See all new features",
];
export const part3 = [
  {
    title: "Reshape MIDI patters",
    content:
      "Apply a variety of simple or complex variations to your MIDI clips with new MIDI Transformations. Add ornaments and articulations, draw acceleration and deceleration curves, connect successive notes and chords, simulate the strum of a guitar, and more.",
  },
  {
    title: "Generate inspiration",
    content:
      "Conjure up melodies, chords and rhythms with the help of new MIDI Generators. Set constraints and let your chosen Generator create playful and original ideas for you to develop and turn into your own.",
  },
];
export const musicList = [
  {
    name: "Music1",
    music: music1,
    popularity: "43.2 K",
  },
  {
    name: "Music2",
    music: music2,
    popularity: "81.2 K",
  },
  {
    name: "Music3",
    music: music3,
    popularity: "32.2 K",
  },
];
